export default "__VITE_ASSET__dStAFbVh__"